import { Injectable } from '@angular/core';
import { URL_SERVICIOS, HTTP_OPTIONS } from '../shared/config/config';
import { HttpClient } from '@angular/common/http';
import { DatatableRootObject, DataTablesResponse } from '../interfaces/interfaces.index';
import { LogOpe, Logs, LogsNav } from '../interfaces/logs';
const URL = `${URL_SERVICIOS}Log`;

@Injectable({
  providedIn: 'root'
})
export class LogsService {

    constructor(private http: HttpClient) { }

    getLogsDataTableAsync = (tableObj: DatatableRootObject) => this.http.post<DataTablesResponse<Logs>>(`${URL}/DatatableAsync`, tableObj, HTTP_OPTIONS);

    getLogsByFilterAsync = (tableObj: DatatableRootObject) => this.http.post<DataTablesResponse<Logs>>(`${URL}/GetLogsByFilterAsync`, tableObj, HTTP_OPTIONS);

    getLogById = (id: number) => this.http.get<Logs>(`${URL}/${id}`, HTTP_OPTIONS);

    addLogNavAsync = (logNav: LogsNav) => this.http.post<LogsNav>(`${URL}/AddLogNavAsync`, logNav, HTTP_OPTIONS);

    getLogsNavByFilterAsync = (tableObj: DatatableRootObject) => this.http.post<DataTablesResponse<LogsNav>>(`${URL}/GetLogsNavByFilterAsync`, tableObj, HTTP_OPTIONS);

    addLogOpeAsync = (LogsOpe: LogOpe) => this.http.post<LogOpe>(`${URL}/AddLogOpeAsync`, LogsOpe, HTTP_OPTIONS);

    getLogsOpeByFilterAsync = (tableObj: DatatableRootObject) => this.http.post<DataTablesResponse<LogOpe>>(`${URL}/GetLogsOpeByFilterAsync`, tableObj, HTTP_OPTIONS);

    getLogOpeById = (id: number) => this.http.get<LogOpe>(`${URL}/GetLogOpeById/${id}`, HTTP_OPTIONS);

    getAllLogs = () => this.http.get<Logs[]>(URL);
}
